import React from 'react';

interface IconProps {
  width?: string;
}

const MelRobbins = ({ width = '130' }: IconProps): JSX.Element => (
  <svg
    width={width}
    viewBox='0 0 130 49'
    className='mel-robbins'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g
      id='Mel Robbins '
      clipPath='url(#clip0_583_7266)'
    >
      <path
        id='Vector'
        d='M1.93701 47.6536C1.93701 47.6536 23.2316 15.8467 26.6904 1.56055C19.1428 13.1511 16.942 30.2223 19.5022 31.5253C22.0625 32.8284 34.3816 6.88437 33.6988 6.86147C33.0161 6.83857 21.88 33.806 26.8701 41.9475C27.7235 43.34 41.2936 27.3165 35.7165 27.4227C31.8567 27.4962 30.1492 38.7579 34.1928 38.7579C39.9045 38.7579 59.9467 8.05765 54.5889 9.96084C46.3676 12.8812 32.98 39.1173 54.0047 40.9588C63.529 41.7934 80.526 35.8375 84 41.5874'
        stroke='white'
        strokeWidth='2.08151'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Path 2'
        d='M61.5488 21.8066H64.898C66.6014 21.8066 67.604 22.821 67.604 24.2302C67.7046 25.2973 67.0392 26.2874 66.0137 26.5983L67.8072 29.835H66.0595L64.5032 26.88H63.06V29.835H61.5495L61.5488 21.8066ZM63.0586 25.5534H64.7051C65.3601 25.6228 65.9478 25.1482 66.0171 24.4932C66.022 24.4446 66.0248 24.396 66.0234 24.3468C66.0234 23.6141 65.5273 23.1402 64.4789 23.1402H63.0579L63.0586 25.5534Z'
        fill='white'
      />
      <path
        id='Path 3'
        d='M79.4388 25.8207C79.4388 28.0867 77.9956 30.0378 75.5928 30.0378C73.19 30.0378 71.7476 28.0867 71.7476 25.8207C71.7476 23.5546 73.1907 21.6035 75.5928 21.6035C77.9949 21.6035 79.4388 23.5539 79.4388 25.8207ZM73.326 25.8207C73.326 27.2187 73.9921 28.6397 75.5928 28.6397C77.1935 28.6397 77.8589 27.2194 77.8589 25.8207C77.8589 24.4219 77.1942 23.0016 75.5928 23.0016C73.9914 23.0016 73.326 24.4219 73.326 25.8207Z'
        fill='white'
      />
      <path
        id='Path 4'
        d='M84 21.8066H87.7779C89.0962 21.8066 90.1571 22.4713 90.1571 23.8028C90.2078 24.6215 89.6076 25.3355 88.7923 25.4264V25.4493C89.8019 25.5506 90.5582 26.42 90.5179 27.4337C90.5179 29.4409 89.0851 29.8357 87.4165 29.8357H84V21.8066ZM85.5112 25.0316H87.3048C87.9694 25.0316 88.5779 24.7721 88.5779 24.0054C88.5779 23.3955 88.1838 23.0021 87.3048 23.0021H85.5112V25.0316ZM85.5112 28.505H87.4734C88.3871 28.505 88.9387 28.2226 88.9387 27.3886C88.9387 26.4866 88.3753 26.1584 87.4623 26.1584H85.5112V28.505Z'
        fill='white'
      />
      <path
        id='Path 5'
        d='M94.9121 21.8066H98.6901C100.008 21.8066 101.07 22.4713 101.07 23.8028C101.121 24.6215 100.52 25.3355 99.7051 25.4264V25.4493C100.715 25.5506 101.471 26.42 101.431 27.4337C101.431 29.4409 99.9979 29.8357 98.33 29.8357H94.9128L94.9121 21.8066ZM96.4226 25.0316H98.2162C98.8809 25.0316 99.4894 24.7721 99.4894 24.0054C99.4894 23.3955 99.0953 23.0021 98.2162 23.0021H96.4226V25.0316ZM96.4226 28.505H98.3848C99.2985 28.505 99.8501 28.2226 99.8501 27.3886C99.8501 26.4866 99.2868 26.1584 98.3737 26.1584H96.4226V28.505Z'
        fill='white'
      />
      <path
        id='Rectangle 1'
        d='M107.412 21.8066H105.901V29.835H107.412V21.8066Z'
        fill='white'
      />
      <path
        id='Path 6'
        d='M112.401 21.8066H113.789L117.16 27.5232H117.183V21.8066H118.558V29.835H117.17L113.799 24.1178H113.776V29.835H112.401V21.8066Z'
        fill='white'
      />
      <path
        id='Path 7'
        d='M124.022 27.4225C124.567 28.2197 125.485 28.6797 126.45 28.6402C127.183 28.6402 128.152 28.3925 128.152 27.6147C128.152 26.9833 127.566 26.8022 126.495 26.5545L125.604 26.3512C124.319 26.0584 123.19 25.588 123.19 24.1073C123.19 22.4157 124.803 21.6039 126.304 21.6039C127.619 21.554 128.872 22.1576 129.653 23.2164L128.404 24.1642C127.986 23.401 127.164 22.9486 126.295 23.0027C125.427 23.0027 124.773 23.3295 124.773 23.8929C124.773 24.5583 125.528 24.7158 126.431 24.9191L127.411 25.1335C128.607 25.3923 129.735 25.8773 129.735 27.3996C129.735 29.3618 127.886 30.0362 126.217 30.0362C124.854 30.0681 123.559 29.4381 122.744 28.3446L124.022 27.4225Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_583_7266'>
        <rect
          width='128.839'
          height='48.1746'
          fill='white'
          transform='translate(0.896484 0.519775)'
        />
      </clipPath>
    </defs>
  </svg>
);

export default MelRobbins;
